import { render } from "./PurchaseModalCoupon.vue?vue&type=template&id=27d2184d"
import script from "./PurchaseModalCoupon.vue?vue&type=script&lang=js"
export * from "./PurchaseModalCoupon.vue?vue&type=script&lang=js"

import exportComponent from "/builds/skilltech-ph/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__